<style lang="less">
  .progress {
    color: white;
    font-size: 16px;
    display: flex;
    span {
      margin-right: 8px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
</style>

<template lang="pug">
  .progress
    span.current {{current}}
    span /
    span.max {{max}}
    span.unit {{unit}}
</template>

<script>
export default {
  props: {
    unit: {
      type: String,
    },
    current: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/current_max_progress.vue